/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"; 
import { useNavigate } from 'react-router-dom';

import { isNull } from "../../../components/common/Common";
import backPageImage from "../../../img/icon/icon-arrow-back.svg";

const HeaderBranchTitle = ({ varPageTitle,varBackString }) => {
  const navigate = useNavigate();

  //백페이지
  const onGotoBackpageHandler = async() => {
    if(isNull(varBackString)){ 
      navigate(-1);
    } else if(varBackString === "none"){ 
      return false;
    } else {
      navigate(varBackString);
    }
  }

  return (
    <div className="vh-content-head">
      {varBackString === "none"?null:
        <button className="his-back left" onClick={onGotoBackpageHandler}><img src={backPageImage} alt="" /></button>
      }
      <h1 className="page-title" style={varBackString==="none"?{width:"100%"}:{}}>{varPageTitle}</h1>
    </div>
  );
}
export default HeaderBranchTitle;